<template>
  <div class="replyTimeOut">
    <el-divider content-position="left">微信回复超时记录</el-divider>
    <el-row class="mb-10" :gutter="10">
      <el-col :span="24">
        <el-select
          style="vertical-align: middle"
          clearable
          v-model="searchArr.chat_id"
          filterable
          remote
          reserve-keyword
          placeholder="输入群名搜素"
          size="mini"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="handleChatNameChange"
        >
          <el-option
            v-for="chat in chats"
            :key="chat.contact_id"
            :label="chat.name"
            :value="chat.contact_id"
          >
          </el-option>
        </el-select>
        <el-date-picker
          style="vertical-align: middle"
          :picker-options="ysyTypeInPickerOptions"
          v-model="searchArr.send_at"
          size="mini"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="发送日期"
          end-placeholder="结束日期"
          @change="handleSendAtChange"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-table height="calc(100vh - 276px)" :data="pageData" size="mini" border style="width: 100%">
      <el-table-column label="群名" prop="chat_name" fixed></el-table-column>
      <el-table-column label="发送人" prop="sender_name"></el-table-column>
      <el-table-column label="内容">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.content" placement="top">
            <span class="hide-style">{{ scope.row.content }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发送时间" prop="send_at" width="140">
        <template slot-scope="scope">
          <date-formatter :date-value="scope.row.send_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-chat-dot-square"
            size="mini"
            circle
            @click="showMessages(scope.row.chat_id, scope.row.chat_name)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :total="pageOption.total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    </div>
    <el-drawer
      title="聊天记录"
      :visible.sync="chatDrawer"
      direction="rtl"
      size="50%"
      :before-close="handleChatBeforeClose"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <chat :chatId="chatId" :chatName="chatName"></chat>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Chat from "common/Chat";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import DateFormatter from 'common/DateFormatter'

export default {
  name: "ReplyTimeOut",
  mixins: [fscDate],
  components: {
    Chat,
    DateFormatter
  },
  data() {
    return {
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      searchArr: {
        chat_id: null,
        send_at: "",
      },
      loading: false,
      chats: [],
      chatId: "",
      chatName: "",
      chatDrawer: false,
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getPageData() {
      this.$axios
        .get(
          "/api/admin/timeout_messages?page=" +
            this.pageOption.currentPage +
            '&pageSize=' +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.pageData = data.data.pageData.data;
            this.pageOption.total = data.data.pageData.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageData();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageData();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchChats(query);
        }, 200);
      } else {
        this.users = [];
      }
    },
    searchChats(query) {
      this.$axios.get("/api/admin/timeout_messages/searchChats/" + query).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.chats = data.data;
        }
      });
    },
    handleChatNameChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    handleSendAtChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    showMessages(chatId, chatName) {
      this.chatDrawer = true;
      setTimeout(() => {
        this.chatId = chatId;
        this.chatName = chatName;
      });
    },
    handleChatBeforeClose(done) {
      this.chatId = "";
      this.chatName = "";
      done();
    },
  },
  mounted() {
    this.getPageData();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.replyTimeOut
  marginLeft()
  .mb-10
    margin-bottom: .2rem
  .mt-10
    margin-top: .2rem
  .text-c
    text-align: center
  .text-r
    text-align: right
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/conversation/ReplyTimeOut.vue